export const DOCX_LIMITS = {
  maxFileBytes: 20 * 1024 * 1024,
  maxUncompressedBytes: 150 * 1024 * 1024,
  maxEntries: 2000,
  maxCompressionRatio: 200,
  renderTimeoutMs: 30_000,
};

export const DOCX_RENDER_OPTIONS = {
  inWrapper: true,
  ignoreFonts: true,
  ignoreLastRenderedPageBreak: true,
  breakPages: true,
  experimental: false,
  debug: false,
  renderAltChunks: false,
  renderComments: false,
  renderChanges: false,
  useBase64URL: true,
};

export const DOCX_ERRORS = {
  empty: 'The file is empty.',
  tooLarge: 'The file is too large to preview.',
  invalid: 'The file is not a valid .docx document.',
  corrupted: 'The .docx file is corrupted.',
  zip64: 'ZIP64 archives are not supported.',
  tooManyParts: 'The document has too many parts.',
  tooLargeUnpacked: 'The document is too large once unpacked.',
  suspiciousCompression: 'Suspicious compression ratio.',
  timeout: 'Rendering the document took too long.',
  download: 'Failed to download the document.',
  generic: 'The document cannot be previewed.',
};

export const IFRAME_CSP = [
  "default-src 'none'",
  'img-src data:',
  'font-src data:',
  "style-src 'unsafe-inline'",
  "base-uri 'none'",
  "form-action 'none'",
  "frame-src 'none'",
  "object-src 'none'",
].join('; ');

export const DOCX_DISCLAIMER_STORAGE_KEY = 'docxPreviewDisclaimerDismissed';

export const DOCX_DEFAULT_DISCLAIMER =
  'The appearance of this document may differ from the original. If styling matters, download the Word file.';
